export function handleKeyDown<T>(e: React.KeyboardEvent<T>, onClick: () => void) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault()
    onClick()
  }
}
